import { useState } from 'react'

import { Label } from '@/components/label/label'
import { Switch } from '@/components/switch/switch'

import type { ResCaseHistoryListQuery } from '@/lib/queries/business/v1/case/types'
import { cn } from '@/lib/utils'

import { useFindTargetCase } from '../hooks/use-find-target-case'
import { Bullet } from './bullet'
import { HistoryItem } from './history-item'

export interface HistoryListProps {
  items: ResCaseHistoryListQuery
}

export const HistoryList: React.FC<HistoryListProps> = ({ items }) => {
  const [showsAllMessages, setShowsAllMessages] = useState(true)

  const filteredItems = showsAllMessages ? items : items.filter(({ type }) => type === 'status')

  const { targetCase } = useFindTargetCase()
  const isUscisCase = targetCase?.applicationType === 'uscis'

  return (
    <>
      {/* Message Show Toggle */}
      {isUscisCase && (
        <div className={cn('flex items-center justify-end', 'px-0 pb-[18px]')}>
          <Label className={cn('text-[12px] font-medium leading-[20px] text-muted-foreground', 'mr-2')}>
            All Messages
          </Label>
          <Switch checked={showsAllMessages} onCheckedChange={setShowsAllMessages} />
        </div>
      )}

      <div className="relative flex" role="list" aria-label="Case history timeline">
        {/* Dashed line */}
        <div className={`absolute bottom-0 left-0 top-0 w-[8.5px] border-r`} />
        {/* Messages */}
        <div className="flex-1 space-y-3" role="list">
          {filteredItems.map((item, i) => {
            return (
              <div
                className="flex"
                key={`${item.type}-${item.received_date}-${item.message}-${targetCase?.case_id}-${i}`}
              >
                {/* Bullet */}
                <div className="relative mr-1 flex w-4 items-center justify-center">
                  {/* Hide dashed line for first and last item. */}
                  {i === 0 && <div className="absolute bottom-1/2 left-0 right-0 top-0 bg-white" />}
                  {i === items.length - 1 && <div className="absolute bottom-0 left-0 right-0 top-1/2 bg-white" />}
                  <Bullet />
                </div>
                <HistoryItem historyItem={item} />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
